import { render, staticRenderFns } from "./downloadChat.vue?vue&type=template&id=4a62888d&scoped=true"
import script from "./downloadChat.vue?vue&type=script&lang=js"
export * from "./downloadChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a62888d",
  null
  
)

export default component.exports